import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';


import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';


import './Test3.css';


class DGRTest3 extends Component {
    state = {
        value: 'female',
    };

    handleChange = event => {
        this.setState({ value: event.target.value });
    };

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
    }
    
    
    render(){
        return (
    
            <ExpansionPanel className="expandPanel" defaultExpanded>
            <ExpansionPanelSummary className="accordHeader"  expandIcon={<ExpandMoreIcon />}>
            Product Type
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>

            <div className="productHolder">
                <div className="productCard">
                    <div className="productCardFlex">
                        <div className="productLeft">
                            <div className="title">
                            Sport Commit
                            </div>
                            <div className="productInfo">
                                12 month commitment required. Prices do not include sales tax 
                                <span> See Membership Details </span>
                            </div>
                            <FormControl component="fieldset" className="">
                              <RadioGroup
                                aria-label="Gender"
                                name="type"
                                value={this.state.value}
                                onChange={this.handleChange}
                              >
                                    <FormControlLabel value="reduced" control={<Radio />} label="Reduced Dues" />
                                    <FormControlLabel value="lower" control={<Radio />} label="Lower Initiation" />

                            </RadioGroup>
                            </FormControl>
                        </div>


                        <div className="productRight">
                            <div className="price">
                                20.99 <span> /mo </span>
                            </div>
                            <div className="initiation">
                                Initiation: $24.99
                            </div>
                            <div className="annual">
                                Annual Fee: $24.99
                            </div>
                            <div className="dueToday">
                                Due Today: $24.99
                            </div>
                            <button className="bigButton">Select</button>
                        </div>
                    </div>
                </div>
            </div>

            </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }
}


DGRTest3  = inject('DGRBackgroundStore')(observer(DGRTest3 ))     
export default DGRTest3  ;



// WEBPACK FOOTER //
// ./src/components/DGR/Test3/Test3.js